// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const setCookie = (
  name: string,
  value: string,
  expires: string,
  _: string,
  isPathValuable = false
): void => {
  document.cookie = `${name}=${value};expires=${expires}${
    isPathValuable ? `;path=/` : ''
  }`;
};

export const getCookie = (cname: string): string => {
  const name = cname + '=';
  const decodedCookie = decodeURIComponent(document.cookie);
  const ca = decodedCookie.split(';');
  // tslint:disable-next-line:prefer-for-of
  for (let c of ca) {
    while (c.charAt(0) === ' ') {
      c = c.slice(1);
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length);
    }
  }
  return '';
};

export const deleteCookie = (
  name: string,
  domain: string,
  isPathValuable = false
): void => {
  setCookie(
    name,
    '',
    `${new Date('Thu, 01 Jan 1970 00:00:01 GMT')}`,
    domain,
    isPathValuable
  );
};
